import { render, staticRenderFns } from "./MilvaMarketForm.vue?vue&type=template&id=5af32867&scoped=true&"
import script from "./MilvaMarketForm.vue?vue&type=script&lang=js&"
export * from "./MilvaMarketForm.vue?vue&type=script&lang=js&"
import style0 from "./MilvaMarketForm.vue?vue&type=style&index=0&id=5af32867&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af32867",
  null
  
)

export default component.exports